export default "__VITE_ASSET__Dldk_YG6__"